export default "__VITE_ASSET__Bsf7FiU3__"